module.exports = __webpack_public_path__ + "img/mp-rank-item__img-5.384b6fcf.jpg";